export const fr = {
  title: 'Potentiel de vitesse du vent',
  subtitle: '1 km, mondial, DTU/Groupe de la Banque mondiale/ESMAP',
  download_data: '',
  learn_more: '',
  content: [
    {
      label: 'Fonction',
      value: 'Vitesse moyenne du vent pour n’importe quel endroit sur Terre',
    },
    {
      label: 'Résolution',
      value: '1 km',
    },
    {
      label: 'Couverture géographique',
      value: 'Global',
    },
    {
      label: 'Source',
      value: '\tDTU/Groupe de la Banque mondiale/ESMAP',
    },
    {
      label: 'Fréquence des mises à jour',
      value: '',
    },
    {
      label: 'Date du contenu',
      value: '',
    },
    {
      label: 'Mises en garde',
      value:
        'La GWA utilise deux composants de modélisation principaux qui peuvent introduire de l’incertitude dans les calculs. Ces composants sont la modélisation à méso-échelle et la modélisation à micro-échelle.',
    },
    {
      label: 'Licence',
      value: '[CC 4.0](https://creativecommons.org/licenses/by/4.0/)',
    },
  ],
  overview: {
    label: 'Aperçu',
    value:
      'L’ensemble de données sur la vitesse moyenne du vent du Global Wind Atlas (GWA) a été généré par le Département de l’énergie éolienne de l’Université technique du Danemark (DTU), le Groupe de la Banque mondiale et le Programme d’assistance à la gestion du secteur de l’énergie (ESMAP).\n\nLa vitesse moyenne du vent est l’un des indicateurs clés de performance de la production d’énergie éolienne. La GWA commence avec des données de vitesse du vent à basse résolution et les convertit en données à haute résolution à l’aide d’un processus de réduction d’échelle. Le résultat de ce processus est un modèle des climats éoliens locaux sur le globe (à l’exception des pôles Nord et Sud et des zones océaniques offshore lointaines) à une résolution de 1 kilomètre pour trois hauteurs : 50 mètres, 100 mètres et 200 mètres.',
  },
  citation: {
    label: 'Citation',
    value:
      'Data/information/map obtained from the Global Wind Atlas 2.0, a free, web-based application developed, owned and operated by the Technical University of Denmark (DTU) in partnership with the World Bank Group, utilizing data provided by Vortex, with funding provided by the Energy Sector Management Assistance Program (ESMAP). For additional information: https://globalwindatlas.info. Accessed through Resource Watch, (date)',
  },
};
